import { FC, PropsWithChildren } from "react";
import { HelpScoutScript } from "~/components/3rd-party/HelpScoutScript";

interface PageLayoutProps extends PropsWithChildren {
  fullWidth?: boolean;
}

export const PageLayout: FC<PageLayoutProps> = ({
  children,
  fullWidth = false,
}) => {
  return (
    <div className={fullWidth ? "w-full" : "max-w-[1920px] mx-auto"}>
      <main>{children}</main>
      <HelpScoutScript />
    </div>
  );
};
